export const OrganizationDbLogSingleResultMockData = [
  {
    organizationId: '5aafadd2-c3bb-43f2-d3ce-08d9f07758ec',
    displayName: 'Test org',
    error: undefined,
    isSuccess: true,
  },
  {
    organizationId: 'f24a232a-3034-4748-1137-08da025277fe',
    displayName: 'Test org 2',
    error: 'Test error',
    isSuccess: false,
  },
];

export const OrganizationDbLogResultMockData = [
  {
    id: '9afd3a2b-ca3d-ee11-b638-2c6dc19c19d5',
    checkDbLogId: '99fd3a2b-ca3d-ee11-b638-2c6dc19c19d5',
    organizationId: '66486b37-bd54-4832-d95c-08db6e58227b',
    organizationName: 'test org',
    success: false,
    errorMessage: 'Test Error',
  },
  {
    id: '9bfd3a2b-ca3d-ee11-b638-2c6dc19c19d5',
    checkDbLogId: '99fd3a2b-ca3d-ee11-b638-2c6dc19c19d5',
    organizationId: 'fc7c3553-d3ea-4538-9192-08db83c643a8',
    organizationName: 'test org 2',
    success: true,
    errorMessage: undefined,
  },
];
